import { MathUtils } from 'three';

export default function degToRad(degrees: number): number {
    return MathUtils.degToRad(degrees);
}
